import './Error.css';

function Error() {
    return (
        <div className="error"><span>Oops! Qualcosa è andato storto.<br/>Riprova!</span></div>
    );
}

export default Error;